import { usePrefersReducedMotion } from "../../common/hooks/usePrefersReducedMotion";
import {
  AtmosphereRoot,
  FogLayer,
  Grain,
  Scanlines,
  Vignette,
} from "./styles";

/**
 * The mood layer: drifting fog, film grain, scanlines and a vignette, painted
 * behind everything and inert to the pointer.
 *
 * Purely decorative, so it's hidden from assistive tech, and the grain stops
 * moving when the visitor prefers reduced motion (the fog is animated in CSS
 * and is stopped by the global reduced-motion rule).
 */
const Atmosphere = () => {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <AtmosphereRoot aria-hidden="true">
      <FogLayer $variant={1} />
      <FogLayer $variant={2} />
      <FogLayer $variant={3} />
      <Scanlines />
      <Grain $animated={!reducedMotion} />
      <Vignette />
    </AtmosphereRoot>
  );
};

export default Atmosphere;
